/**
 * Jichica Weather Info - Vanilla JS Version
 */
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('jichica-weather-news');
    if (!container) return;

    // shared-loader.php で localize した設定値を取得
    // const weatherVars = window.jichica_weather_vars || {
    //     ajax_url: '/wp-admin/admin-ajax.php',
    //     city_name: '地域'
    // };

    // shared-loader.php で localize した myJichicaConfig.weather を取得
    const weatherVars = (window.myJichicaConfig && window.myJichicaConfig.weather) || {
        ajax_url: '/wp-admin/admin-ajax.php',
        city_name: '地域'
    };

    // WordPress の admin-ajax.php 用に FormData を準備
    const formData = new FormData();
    formData.append('action', 'get_jichica_weather');

    // Fetch API を使用した非同期通信
    fetch(weatherVars.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(res => {
        if (res.success) {
            const data = res.data;
            // const cityName = data.city || weatherVars.city_name;

            let html = `<h3 class="fs-l title-2 bold">神奈川県の気象情報（警報・注意報）ほか</h3>`;

            if (data.alerts && data.alerts.length > 0) {
                html += '<ul class="mgt-m news-list-container list-style-none no-padding">';

                data.alerts.forEach(item => {
                    // 日付処理
                    // const dateObj = new Date(item.updated);
                    // let timeDisplay = "";

                    // if (!isNaN(dateObj.getTime())) {
                    //     const year = dateObj.getFullYear();
                    //     const month = dateObj.getMonth() + 1;
                    //     const day = dateObj.getDate();
                    //     const hour = dateObj.getHours();
                    //     const min = dateObj.getMinutes().toString().padStart(2, '0');
                    //     const period = hour < 12 ? '午前' : '午後';
                    //     const displayHour = hour % 12 || 12;

                    //     timeDisplay = `${year}年${month}月${day}日 ${period}${displayHour}時${min}分`;
                    // }

                    html += `
                        <li class="mgt-s lh-1-5 al-l w-100 bg-wht radius-s padding-box-s">
                            <div class="flex flex-wrap flex-al-c gap-xs bold mgb-02">
                                <span class="time c-text-gray fs-ss">${item.updated}</span>
                                <span class="c-bousai fs-m">${item.title}</span>
                            </div>
                            ${item.content ? `<p class="fs-s mgt-05 lh-1-4" style="color: #444;">${item.content}</p>` : ''}
                        </li>`;
                });

                html += '</ul>';
            } else {
                html += '<p class="mgt-m fs-s" style="color:#666;">現在、発表中の警報・注意報はありません。</p>';
            }

            if (data.jma_url) {
                html += `
                    <div class="mgt-m al-r">
                        <a href="${data.jma_url}" target="_blank" rel="noopener" class="btn-text fs-ss">
                            気象庁のサイトで詳細を確認する
                        </a>
                    </div>`;
            }
            // コンテンツの反映
            container.innerHTML = html;
        } else {
            container.innerHTML = '<p class="mgt-m fs-s">情報の取得に失敗しました。</p>';
        }
    })
    .catch(error => {
        console.error('Weather Info Error:', error);
        container.innerHTML = '<p class="mgt-m fs-s">通信エラーが発生しました。</p>';
    });
});